import { Component, Inject, Input, OnInit } from '@angular/core';
import { JardinModel } from 'src/app/model/Jardin.model';
import { DimensionesPMEModel, SubdimensionPMEModel } from 'src/app/model/NewFaseEstrategica.model';
import { apiService } from 'src/app/service/api.service';
import { PlanMejoraService } from 'src/app/service/planMejora.service';
import Swal from 'sweetalert2';
import { PmeFaseEstrategicaComponent } from '../../pme-fase-estrategica.component';


@Component({
  selector: 'app-pme-dimensiones',
  templateUrl: './pme-dimensiones.component.html',
  styleUrls: ['./pme-dimensiones.component.css']
})
export class PmeDimensionesComponent implements OnInit {

  @Input() dimensionData : DimensionesPMEModel;
  @Input() estadoData : number;
  @Input() dataJardin : JardinModel;
  @Input() simulacion: boolean;

  cargando: boolean;

  //objetivosAreas = new Array<ObjetivosAreaJardinModel>();
  subdimensiones = new Array<SubdimensionPMEModel>();

  public isCollapsed = true;

  constructor(
    @Inject(PmeFaseEstrategicaComponent) private parentFE: PmeFaseEstrategicaComponent,
    private api: apiService,
    private planMejoraService: PlanMejoraService
    ) { }

  ngOnInit(): void {
   // this.objetivosAreas = this.areaData.objetivosAreas;
    this.subdimensiones = this.dimensionData.subdimensiones;
    this.cargaInicial();
  }

  cargaInicial(){
    this.dataJardin = this.api.dataJardin;
  }

  // addNuevoObjetivo(objetivosAreas): void {
  //   objetivosAreas.push(new ObjetivosAreaJardinModel());
  // }

  // borrarObjetivo(objetivosAreas): void {
  //     Swal.fire({
  //       title: '¿Está seguro que desea borrar el Objetivo?',
  //       showDenyButton: false,
  //       showCancelButton: true,
  //       confirmButtonText: 'Continuar',
  //       cancelButtonText: 'Cancelar',
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         if (objetivosAreas.length == 2 && (objetivosAreas[objetivosAreas.length-1].idObjetivo !=-1 && objetivosAreas[objetivosAreas.length-1].idObjetivo !=null)) {
  //           this.borrarObjetivoBD(objetivosAreas.pop());
  //         } else {
  //           objetivosAreas.pop();
  //         }
  //         Swal.fire({
  //           title: 'Objetivo borrado!',
  //           icon: 'info',
  //           confirmButtonText: 'OK'
  //         })
  //       }
  //     });
  // }

  // borrarObjetivoBD( objetivo : ObjetivosAreaJardinModel){
  //   this.planMejoraService.API_POST_borrarObjetivoFaseEstrategica(this.dataJardin.id,objetivo.idObjetivo).subscribe((response:any) => {
  //   },
  //   (err) => {
  //     console.log(err)
  //   });
  // }
}
